export const INITIATE_TRANSFER_OFFPLAN_APPLICATION = 'INITIATE_TRANSFER_OFFPLAN_APPLICATION';
export const INITIATE_TRANSFER_OFFPLAN_APPLICATION_SUCCESS = 'INITIATE_TRANSFER_OFFPLAN_APPLICATION_SUCCESS';
export const INITIATE_TRANSFER_OFFPLAN_APPLICATION_ERROR = 'INITIATE_TRANSFER_OFFPLAN_APPLICATION_ERROR';
export const INITIATE_TRANSFER_OFFPLAN_APPLICATION_FAIL = 'INITIATE_TRANSFER_OFFPLAN_APPLICATION_FAIL';

export const CLEAR_TRANSFER_OFFPLAN_APPLICATION_ERROR = 'CLEAR_TRANSFER_OFFPLAN_APPLICATION_ERROR';

export const TRANSFER_OFFPLAN_LOADING = 'TRANSFER_OFFPLAN_LOADING';
export const FETCH_APPLICATION_TRANSFER_OFFPLAN_SUCCESS = 'FETCH_APPLICATION_TRANSFER_OFFPLAN_SUCCESS';
export const FETCH_PROPERTY_TRANSFER_OFFPLAN_SUCCESS = 'FETCH_PROPERTY_TRANSFER_OFFPLAN_SUCCESS';
export const FETCH_BANKLIST_TRANSFER_OFFPLAN_SUCCESS = 'FETCH_BANKLIST_TRANSFER_OFFPLAN_SUCCESS';
export const FETCH_DOCUMENTS_TRANSFER_OFFPLAN_SUCCESS = 'FETCH_DOCUMENTS_TRANSFER_OFFPLAN_SUCCESS';
export const TRANSFER_OFFPLAN_ERROR = 'TRANSFER_OFFPLAN_ERROR';

export const SET_CONTRACT_DETAILS_TEST = 'SET_CONTRACT_DETAILS_TEST';
export const SET_REGESTRATION_FEES_PAID_BY = 'SET_REGESTRATION_FEES_PAID_BY';

export const SAVE_APPLICATION_TRANSFER_OFFPLAN = 'SAVE_APPLICATION_TRANSFER_OFFPLAN';
export const SAVE_APPLICATION_TRANSFER_OFFPLAN_SUCCESS = 'SAVE_APPLICATION_TRANSFER_OFFPLAN_SUCCESS';
export const SAVE_APPLICATION_TRANSFER_OFFPLAN_ERROR = 'SAVE_APPLICATION_TRANSFER_OFFPLAN_ERROR';

export const CHANGE_TRANSFER_OFFPLAN_STEP = 'CHANGE_TRANSFER_OFFPLAN_STEP';
export const TRANSFER_OFFPLAN_CLEAR_DATA = 'TRANSFER_OFFPLAN_CLEAR_DATA';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';
export const ADD_TO_ERROR_INITITATE = 'ADD_TO_ERROR_INITITATE';

export const UPLOAD_TRANSFER_OFFPLAN_DOCUMENT = 'UPLOAD_TRANSFER_OFFPLAN_DOCUMENT';
export const UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_SUCCESS = 'UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_SUCCESS';
export const UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_ERROR = 'UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_ERROR';

export const CHECKOUT_TRANSFER_OFFPLAN_APPLICATION = 'CHECKOUT_TRANSFER_OFFPLAN_APPLICATION';
export const CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_SUCCESS = 'CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_SUCCESS';
export const CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_ERROR = 'CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_ERROR';

export const TRANSFER_OFFPLAN_CANCEL_APPLICATION = 'TRANSFER_OFFPLAN_CANCEL_APPLICATION';
export const TRANSFER_OFFPLAN_CANCEL_APPLICATION_SUCCESS = 'TRANSFER_OFFPLAN_CANCEL_APPLICATION_SUCCESS';
export const TRANSFER_OFFPLAN_CANCEL_APPLICATION_ERROR = 'TRANSFER_OFFPLAN_CANCEL_APPLICATION_ERROR';
export const ENROLL_PROPERTY_IN_TAWTHEEQ = 'ENROLL_PROPERTY_IN_TAWTHEEQ';
/** --------------- TRANSFER_OFFPLAN BANK MAKER --------------- */
export const SET_TRANSFER_OFFPLAN_BANK_MAKER_DETAILS = 'SET_TRANSFER_OFFPLAN_BANK_MAKER_DETAILS';

export const FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION = 'FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION';
// eslint-disable-next-line prettier/prettier
export const FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS = 'FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS';

// eslint-disable-next-line prettier/prettier
export const FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR = 'FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR';

export const SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION = 'SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION';
// eslint-disable-next-line prettier/prettier
export const SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS = 'SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS';
export const SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR = 'SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR';

export const FETCH_TRANSFER_OFFPLAN_VALUATORS = 'FETCH_TRANSFER_OFFPLAN_VALUATORS';
export const FETCH_TRANSFER_OFFPLAN_VALUATORS_SUCCESS = 'FETCH_TRANSFER_OFFPLAN_VALUATORS_SUCCESS';
export const FETCH_TRANSFER_OFFPLAN_VALUATORS_ERROR = 'FETCH_TRANSFER_OFFPLAN_VALUATORS_ERROR';
export const CLEAR_TRANSFER_OFFPLAN_VALUATORS = 'CLEAR_TRANSFER_OFFPLAN_VALUATORS';

// post flow
export const APPROVAL_TRANSFER_OFFPLAN = 'APPROVAL_TRANSFER_OFFPLAN';
export const APPROVAL_TRANSFER_OFFPLAN_SUCCESS = 'APPROVAL_TRANSFER_OFFPLAN_SUCCESS';
export const APPROVAL_TRANSFER_OFFPLAN_ERROR = 'APPROVAL_TRANSFER_OFFPLAN_ERROR';

export const POST_RETURN_TRANSFER_OFFPLAN = 'POST_RETURN_TRANSFER_OFFPLAN';
export const POST_RETURN_TRANSFER_OFFPLAN_SUCCESS = 'POST_RETURN_TRANSFER_OFFPLAN_SUCCESS';
export const POST_RETURN_TRANSFER_OFFPLAN_ERROR = 'POST_RETURN_TRANSFER_OFFPLAN_ERROR';

export const TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN = 'TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN';
export const TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_SUCCESS = 'TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_SUCCESS';
export const TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_ERROR = 'TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_ERROR';

export const DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT = 'DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT';
export const DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_SUCCESS =
  'DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_SUCCESS';
export const DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_ERROR = 'DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_ERROR';

// Actions Type Start

export const ESCROW_ACCOUNT_ERROR = 'ESCROW_ACCOUNT_ERROR';
export const ESCROW_ACCOUNT_LOADING = 'ESCROW_ACCOUNT_LOADING';

export const ESCROW_ACCOUNT_LOADING_IN_MODAL = 'ESCROW_ACCOUNT_LOADING_IN_MODAL';

export const SAVE_AGREEMENT_DETAILS = 'SAVE_AGREEMENT_DETAILS';
export const SAVE_AGREEMENT_DETAILS_SUCCESS = 'SAVE_AGREEMENT_DETAILS_SUCCESS';
export const SAVE_AGREEMENT_DETAILS_ERROR = 'SAVE_AGREEMENT_DETAILS_ERROR';

export const FETCH_ACCOUNT_TRUSTEE = 'FETCH_ACCOUNT_TRUSTEE';
export const FETCH_ACCOUNT_TRUSTEE_SUCCESS = 'FETCH_ACCOUNT_TRUSTEE_SUCCESS';
export const FETCH_ACCOUNT_TRUSTEE_ERROR = 'FETCH_ACCOUNT_TRUSTEE_ERROR';

export const FETCH_APPLICATION_ESCROW_ACCOUNT_DETAIL = 'FETCH_APPLICATION_ESCROW_ACCOUNT_DETAIL';
export const FETCH_APPLICATION_ESCROW_ACCOUNT_DETAIL_SUCCESS = 'FETCH_APPLICATION_ESCROW_ACCOUNT_DETAIL_SUCCESS';

export const CLEAR_ESCROW_ACCOUNT_APPLICATION_ERROR = 'CLEAR_ESCROW_ACCOUNT_APPLICATION_ERROR';

export const UPDATE_AGREEMENT_DETAILS_DATA = 'UPDATE_AGREEMENT_DETAILS_DATA';

export const UPDATE_SPECIAL_CONDITION_DATA = 'UPDATE_SPECIAL_CONDITION_DATA';

export const FETCH_SPECIAL_CONDITION_SUCCESS = 'FETCH_SPECIAL_CONDITION_SUCCESS';

export const ADD_SPECIAL_CONDITION = 'ADD_SPECIAL_CONDITION';
export const ADD_SPECIAL_CONDITION_SUCCESS = 'ADD_SPECIAL_CONDITION_SUCCESS';
export const ADD_SPECIAL_CONDITION_ERROR = 'ADD_SPECIAL_CONDITION_ERROR';

export const REMOVE_SPECIAL_CONDITION = 'REMOVE_SPECIAL_CONDITION';
export const REMOVE_SPECIAL_CONDITION_SUCCESS = 'REMOVE_SPECIAL_CONDITION_SUCCESS';
export const REMOVE_SPECIAL_CONDITION_ERROR = 'REMOVE_SPECIAL_CONDITION_ERROR';

export const EDIT_SPECIAL_CONDITION = 'EDIT_SPECIAL_CONDITION';
export const EDIT_SPECIAL_CONDITION_SUCCESS = 'EDIT_SPECIAL_CONDITION_SUCCESS';
export const EDIT_SPECIAL_CONDITION_ERROR = 'EDIT_SPECIAL_CONDITION_ERROR';

export const ADD_ADMINSTRATION_FEES_SCHEDULE = 'ADD_ADMINSTRATION_FEES_SCHEDULE';
export const ADD_ADMINSTRATION_FEES_SCHEDULE_SUCCESS = 'ADD_ADMINSTRATION_FEES_SCHEDULE_SUCCESS';
export const ADD_ADMINSTRATION_FEES_SCHEDULE_ERROR = 'ADD_ADMINSTRATION_FEES_SCHEDULE_ERROR';

export const EDIT_ADMINSTRATION_FEES_SCHEDULE = 'EDIT_ADMINSTRATION_FEES_SCHEDULE';
export const EDIT_ADMINSTRATION_FEES_SCHEDULE_SUCCESS = 'EDIT_ADMINSTRATION_FEES_SCHEDULE_SUCCESS';
export const EDIT_ADMINSTRATION_FEES_SCHEDULE_ERROR = 'EDIT_ADMINSTRATION_FEES_SCHEDULE_ERROR';

export const REMOVE_ADMINSTRATION_FEES_SCHEDULE = 'REMOVE_ADMINSTRATION_FEES_SCHEDULE';
export const REMOVE_ADMINSTRATION_FEES_SCHEDULE_SUCCESS = 'REMOVE_ADMINSTRATION_FEES_SCHEDULE_SUCCESS';
export const REMOVE_ADMINSTRATION_FEES_SCHEDULE_ERROR = 'REMOVE_ADMINSTRATION_FEES_SCHEDULE_ERROR';

export const UPDATE_ADMINSTRATION_FEES_SCHEDULE_DATA = 'UPDATE_ADMINSTRATION_FEES_SCHEDULE_DATA';
export const FETCH_ADMINSTRATION_FEES_SCHEDULE_SUCCESS = 'FETCH_ADMINSTRATION_FEES_SCHEDULE_SUCCESS';

export const DEVELOPER_APPROVAL = 'DEVELOPER_APPROVAL';
export const DEVELOPER_APPROVAL_SUCCESS = 'DEVELOPER_APPROVAL_SUCCESS';
export const DEVELOPER_APPROVAL_ERROR = 'DEVELOPER_APPROVAL_ERROR';

export const BANK_CHECKER_APPROVAL = 'BANK_CHECKER_APPROVAL';
export const BANK_CHECKER_APPROVAL_SUCCESS = 'BANK_CHECKER_APPROVAL_SUCCESS';
export const BANK_CHECKER_APPROVAL_ERROR = 'BANK_CHECKER_APPROVAL_ERROR';

export const BANK_SIGNATORY_APPROVAL = 'BANK_SIGNATORY_APPROVAL';
export const BANK_SIGNATORY_APPROVAL_SUCCESS = 'BANK_SIGNATORY_APPROVAL_SUCCESS';
export const BANK_SIGNATORY_APPROVAL_ERROR = 'BANK_SIGNATORY_APPROVAL_ERROR';

export const DEVELOPER__SIGNATORY_APPROVAL = 'DEVELOPER__SIGNATORY_APPROVAL';
export const DEVELOPER__SIGNATORY_APPROVAL_SUCCESS = 'DEVELOPER__SIGNATORY_APPROVAL_SUCCESS';
export const DEVELOPER__SIGNATORY_APPROVAL_ERROR = 'DEVELOPER__SIGNATORY_APPROVAL_ERROR';

export const REJECT_WITH_REASON = 'REJECT_WITH_REASON';
export const REJECT_WITH_REASON_SUCCESS = 'REJECT_WITH_REASON_SUCCESS';
export const REJECT_WITH_REASON_ERROR = 'REJECT_WITH_REASON_ERROR';

export const UPDATE_ACCOUNT_DETAILS = 'UPDATE_ACCOUNT_DETAILS';
export const INITIATE_ESCROW_ACCOUNT_APPLICATION = 'INITIATE_ESCROW_ACCOUNT_APPLICATION';
export const INITIATE_ESCROW_ACCOUNT_APPLICATION_SUCCESS = 'INITIATE_ESCROW_ACCOUNT_APPLICATION_SUCCESS';
export const ESCROW_ACCOUNT_LOADING_SUCCESS = 'ESCROW_ACCOUNT_LOADING_SUCCESS';
export const FETCH_APPLICATION_ESCROW_ACCOUNT_SUCCESS = 'FETCH_APPLICATION_ESCROW_ACCOUNT_SUCCESS';

export const ESCROW_ACCOUNT_PAYMENT_BREAKDOWN = 'ESCROW_ACCOUNT_PAYMENT_BREAKDOWN';
export const ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_ERROR = 'ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_ERROR';
export const ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_SUCCESS = 'ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_SUCCESS';

export const DOWNLOAD_DOCUMENT_ESCROW = 'DOWNLOAD_DOCUMENT_ESCROW';
export const DOWNLOAD_DOCUMENT_ESCROW_SUCCESS = 'DOWNLOAD_DOCUMENT_ESCROW_SUCCESS';
export const DOWNLOAD_DOCUMENT_ESCROW_ERROR = 'DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN_ERROR';

export const RESET_ESCROW_ACCOUNT_ERROR = 'RESET_ESCROW_ACCOUNT_ERROR';
